"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jwksPubSchema = exports.jwksSchema = void 0;
const zod_1 = require("zod");
const jwk_js_1 = require("./jwk.js");
/**
 * JSON Web Key Set schema. The keys set, in this context, represents a
 * collection of JSON Web Keys (JWKs), that can be both public and private.
 */
exports.jwksSchema = zod_1.z.object({
    keys: zod_1.z.array(jwk_js_1.jwkSchema),
});
/**
 * Public JSON Web Key Set schema. All keys must be public keys, have a `kid`,
 * and `use` or `key_ops` defined.
 */
exports.jwksPubSchema = zod_1.z.object({
    keys: zod_1.z.array(jwk_js_1.jwkPubSchema),
});
//# sourceMappingURL=jwks.js.map